// extracted by mini-css-extract-plugin
export default {"decorativeLine":"shareModuleStyle_decorativeLine__pyRUS","heading":"shareModuleStyle_heading__NX2AK","headingText":"shareModuleStyle_headingText__Pi4Q3"};